import { useEffect, useState } from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { usePullCpoLocationsMutation } from 'src/core/service/location.service';
import { useTranslation } from 'react-i18next';
import { Snackbar } from 'src/shared/snackbar/snackbar';
import { CloudSync } from '@mui/icons-material';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { DialogTitle, DialogActions, Button } from '@mui/material';

type Props = {
  readonly cpoId: string;
  readonly label: string;
};

export function PullCpoLocationsAction(props: Props): React.JSX.Element {
  const { t } = useTranslation();
  const { cpoId, label } = props;
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [pullCpoLocations, { error, isLoading }] =
    usePullCpoLocationsMutation();

  useEffect(() => {
    if (triggerFetch) {
      pullCpoLocations({ cpoId });
      setTriggerFetch(false);
    }
  }, [triggerFetch, pullCpoLocations, cpoId]);

  const handleClick = () => {
    setOpenDialog(true);
  };

  const handleConfirm = () => {
    setTriggerFetch(true);
    setOpenDialog(false);
  };

  const handleCancel = () => {
    setOpenDialog(false);
  };

  return (
    <>
      {isLoading && (
        <GridActionsCellItem label={label} icon={<HourglassBottomIcon />} />
      )}
      {!isLoading && (
        <GridActionsCellItem
          label={label}
          icon={<CloudSync />}
          onClick={handleClick}
        />
      )}
      <Dialog open={openDialog} onClose={handleCancel}>
        <DialogTitle>
          {t('model.cpo.pull-locations-confirmation-title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('model.cpo.pull-locations-confirmation-message')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {t('model.cpo.pull-locations-confirmation-cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {t('model.cpo.pull-locations-confirmation-confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      {error && (
        <Snackbar
          variant="error"
          message={t('error.pull-cpo-locations-mutation')}
        />
      )}
    </>
  );
}
